<template>
  <div id="reset">
    <!-- 手机端注册 -->
    <div class="phone" v-if="flag == 2">
      <my_dialog v-if="dialogData.flag" :myDialogData="dialogData"> </my_dialog>
    </div>
    <!-- PC端注册 -->
    <div class="pc" v-if="flag == 1">
      <my_dialogPc v-if="dialogData.flag" :myDialogData="dialogData">
      </my_dialogPc>
    </div>
  </div>
</template>

<script>
import * as resetData from "./reset.js";

export default {
  data() {
    return {
      flag: 0, //手机端和PC端
      dialogData: {
        flag: false,
        title: "重置密码",
        data: [],
        btnName: "下一步",
      },
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
        this.met();
      } else {
        // this.flag = 2;
        // this.met();
        this.$message({
          type: "warning",
          message: "请用电脑端查看!",
        });
        return;
      }
    },
    met() {
      this.dialogData.flag = true;
      this.dialogData.data = resetData.getresetDialogData();
    },
  },
  mounted() {
    this.start();
  },
};
</script>

<style lang="less" scoped>
#reset {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .phone {
    width: 100%;
    height: 100%;
  }
  .pc {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);
  }
}
</style>
